<h4 class="text-danger text-center my-5" i18n="@@dialog.attribute.function.restricted">Could not edit function for selected attribute.</h4>
